import React, { type ComponentProps, type ReactElement } from 'react';
import { useIntl } from 'react-intl-next';

import { DateSharedCssClassName } from '@atlaskit/editor-common/styles/date';
import { timestampToString, timestampToTaskContext } from '@atlaskit/editor-common/utils/date';
import type { Date as OriginalDate } from '@atlaskit/renderer/nodes';
import { useRendererContext } from '@atlaskit/renderer/renderer-context';

import type { LightNodeProps } from '../LightNodeObserver.ts';

export const Date = (props: ComponentProps<typeof OriginalDate> & LightNodeProps): ReactElement => {
	const intl = useIntl();
	const { timeZone } = useRendererContext();

	return (
		<span
			ref={props.lightNodeRef}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Platform's Renderer stylesheet owns canonical date geometry.
			className={DateSharedCssClassName.DATE_WRAPPER}
		>
			<span
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Platform's Renderer stylesheet owns canonical date geometry.
				className="date-node"
				data-node-type="date"
				data-timestamp={props.timestamp}
			>
				{props.parentIsIncompleteTask
					? timestampToTaskContext(props.timestamp, intl, timeZone)
					: timestampToString(props.timestamp, intl)}
			</span>
		</span>
	);
};
